import { Sparkles, Trash2, Loader2, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ChartRenderer } from "@/components/chat/ChartRenderer";
import { BOARD } from "@/constants/testIds";

export function DashboardWidget({ widget, onExplain, onRemove, explaining, canEdit }) {
  return (
    <div data-testid={BOARD.widget} className="flex flex-col rounded-xl border border-border/60 bg-card/50 p-4">
      <div className="flex items-start justify-between gap-2">
        <h3 className="text-sm font-semibold leading-snug text-foreground/90">{widget.title}</h3>
        {canEdit && onRemove && (
          <button
            data-testid={BOARD.widgetRemove}
            onClick={() => onRemove(widget)}
            aria-label="Remove widget"
            className="shrink-0 rounded-full p-1 text-muted-foreground transition-colors hover:text-red-400"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        )}
      </div>

      <div className="mt-3 min-h-[220px]">
        {widget.error ? (
          <div className="flex items-center gap-2 rounded-lg border border-red-500/30 bg-red-500/5 p-3 text-xs text-red-400">
            <AlertTriangle className="h-4 w-4 shrink-0" /> {widget.error}
          </div>
        ) : (
          <ChartRenderer chart={widget.chart} />
        )}
      </div>

      <div className="mt-3 flex items-center justify-between">
        <Button
          variant="outline"
          size="sm"
          data-testid={BOARD.widgetExplain}
          disabled={explaining || !!widget.error}
          onClick={() => onExplain(widget)}
          className="h-7 rounded-full border-accent/40 text-[11px] text-accent hover:bg-accent/10"
        >
          {explaining ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Sparkles className="mr-1.5 h-3.5 w-3.5" />}
          Explain this chart
        </Button>
      </div>

      {widget.explanation && (
        <div
          data-testid={BOARD.widgetExplanation}
          className="mt-3 rounded-lg border border-border/50 bg-background/40 p-3 text-xs leading-relaxed text-muted-foreground"
        >
          {widget.explanation}
        </div>
      )}
    </div>
  );
}
